import { render } from "./Text.vue?vue&type=template&id=9318b276&scoped=true&bindings={\"id\":\"props\",\"replaces\":\"props\",\"loading\":\"data\",\"text\":\"data\",\"lan\":\"options\",\"getText\":\"options\",\"doReplaces\":\"options\"}"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=9318b276&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9318b276"

export default script